import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;
const URL = `${env.REACT_APP_API_URL}/api/user`;
const URL_LOGOUT = `${env.REACT_APP_API_URL}/api/user/release`;
const URL_SEARCH = `${env.REACT_APP_API_URL}/api/employee/search`;
const URL_TOKEN = `${env.REACT_APP_API_URL}/api/User/RefreshToken`;
const URL_ID = `${env.REACT_APP_API_URL}/api/employee`;
const URL_ROLE = `${env.REACT_APP_API_URL}/api/role/search`;
const URL_VERIFIED = `${env.REACT_APP_API_URL}/api/user/validatepassword`;
const URL_EDIT_PASSWORD = `${env.REACT_APP_API_URL}/api/user/updatepassword`;
const URL_EDIT_PASS_NO_TOKEN = `${env.REACT_APP_API_URL}/api/user/UpdateForgotPasswordWithoutToken`;
const URL_RESET_USER = `${env.REACT_APP_API_URL}/api/user/reset`;
const URL_UNLOCK = `${env.REACT_APP_API_URL}/api/user/LockUnlock`;
const URL_ACTIVE = `${env.REACT_APP_API_URL}/api/user/ActiveInactive`;
const URL_LOGS = `${env.REACT_APP_API_URL}/api/datalog`;

export const getToken = (payload) => {
  return axios
    .get(URL_TOKEN, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getDashboard = (payload) => {
  return axios
    .get(`${URL}/Dashboard`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getAll = (payload) => {
  return axios
    .get(URL_SEARCH, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getRole = (payload) => {
  return axios
    .get(URL_ROLE, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getId = (id) => {
  return axios
    .get(`${URL_ID}/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdUser = (id) => {
  return axios
    .get(`${URL_ORI}/api/user/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdEmployee = (id) => {
  return axios
    .get(`${URL_ORI}/employee/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getDataLog = (id) => {
  return axios.get(`${URL_LOGS}/${id}`, {
    params: id,
  });
};

export const getVerifiedPassword = (id) => {
  return axios
    .get(`${URL_VERIFIED}/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createItem = (payload) => {
  return axios.post(URL, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const logoutUser = (payload) => {
  return axios.post(URL_LOGOUT, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createEmploye = (payload) => {
  return axios.post(`${URL_ORI}/api/employee`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateEmployee = (payload) => {
  return axios.put(`${URL_ORI}/api/employee`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateRole = (payload) => {
  return axios.put(`${URL_ORI}/api/role`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createRole = (payload) => {
  return axios.post(`${URL_ORI}/api/role`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createRoleDuplicate = (payload) => {
  return axios.post(`${URL_ORI}/api/role/duplicate`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const changeOffice = (payload) => {
  return axios
    .post(`${URL_ORI}/api/user/AssignOffice`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createOfficeUser = (payload) => {
  return axios.post(`${URL_ORI}/api/User/AddOffice`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateOfficeUser = (payload) => {
  return axios
    .put(`${URL_ORI}/api/User/updateOffice`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateItem = (payload) => {
  return axios.put(URL, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteByIdRole = (payload) => {
  return axios.delete(`${URL_ORI}/api/role`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteUserOffice = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/user/deleteOffice`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const editPassword = (payload) => {
  return axios.post(`${URL_EDIT_PASSWORD}`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const editPasswordNoToken = (payload) => {
  return axios.post(`${URL_EDIT_PASS_NO_TOKEN}`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const resetUser = (payload) => {
  return axios.post(URL_RESET_USER, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const unlockUser = (payload) => {
  return axios.post(URL_UNLOCK, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const activeUser = (payload) => {
  return axios.post(URL_ACTIVE, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getPermissionId = (id) => {
  return axios.get(`${URL_ORI}/api/role/permission/${id}`, {
    params: id,
  });
};

export const updatePermission = (payload) => {
  return axios.put(`${URL_ORI}/api/role/permission`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
